import BetaVersion from "./addVersions/beta_version";
import PortalVerion from "./addVersions/portal_version";

const AddVehicle = () => {
  return (
    <BetaVersion />
    // <PortalVerion />
  )
}

export default AddVehicle;
